import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { State } from '../../types/StateType'
import { AddsDataEntityType, GetAddsDataActionType } from './types'

const addsDataAdapter = createEntityAdapter<AddsDataEntityType>({
  selectId: (alert) => alert.key,
})

let definedProps: { error: any; loading: boolean; success: any } = {
  error: null,
  loading: false,
  success: null,
}

const initialState = addsDataAdapter.getInitialState(definedProps)

const addsDataSlice = createSlice({
  name: 'addsData',
  initialState: initialState,
  reducers: {
    getAddsData: (state, action: PayloadAction<GetAddsDataActionType>) => {
      state.loading = true
      state.error = null
    },
    addAddsData: (state, action: PayloadAction<AddsDataEntityType>) => {
      state.loading = false
      state.error = null
      addsDataAdapter.removeOne(state, action.payload.key)
      addsDataAdapter.addOne(state, action.payload)
    },
    errorAddsData: (state, action: PayloadAction<string | null>) => {
      state.loading = false
      state.error = action.payload
    },
  },
})

export const { addAddsData, errorAddsData, getAddsData } = addsDataSlice.actions

export default addsDataSlice.reducer

const { selectById } = addsDataAdapter.getSelectors()

export const selectAddsDataByKey = (key: string) =>
  createSelector(
    (state: State) => state.addsDataState,
    (addsData) => selectById(addsData, key)
  )

export const selectAddsDataLoading = (state: State) =>
  state.addsDataState.loading

export const selectAddsDataError = (state: State) => state.addsDataState.error
